<template>
  <div class="mt-2" style="position: relative">
    <div class="card card-margin">
      <b-tooltip target="orderNameTitle" triggers="hover"
        >We require that you enter a name for your order. This is used for
        reference purposes should you have any questions later.
      </b-tooltip>
      <b-col>
        <div class="item-title mb-2 mt-2">
          Order Name<icon
            id="orderNameTitle"
            name="question-circle"
            title="help"
            class="question"
          />
        </div>
        <b-input
          placeholder="Enter order name"
          :value="orderContact.OrderName"
          data-test="summary-pay-orderName"
          @input.native="updateContact('OrderName', $event)"
        ></b-input>
        <m-error-text
          :val="orderContact.OrderName"
          :immediate="showError"
          :rules="['require']"
        />
      </b-col>

      <m-question
        :link="
          $store.getters['config/link']('agreementQuestion') +
          '&siteId=' +
          $store.state.site.SiteId
        "
      ></m-question>
      <div class="m-disabled-box display-style" v-if="!enablePlaceOrder"></div>

      <b-form-checkbox
        class="item display-style mt-1 mb-1"
        v-model="aggreAgreement"
        data-test="summary-term-agree"
      >
        <span v-if="IsEmailCampaign" name="email"
          >I understand that USADATA will deploy this campaign and that I will
          not receive any actual email addresses with this order.</span
        >
        <span v-if="!IsEmailCampaign" name="notemail"
          >I agree to the terms and conditions of the
          <b-link
            tabindex="-1"
            href="javascript:void(0)"
            @click="showdatauseagreement"
            class="data-use-agreement"
            >Data Use Agreement</b-link
          >
          <span id="asterisk_before" class="color_red">*</span>
          and acknowledge that orders with consumer phone numbers or sensitive
          elements may be put on hold. (*)
          <icon
            name="question-circle"
            title="help"
            class="question"
            @click.native="showQuestion"
        /></span>
      </b-form-checkbox>

      <p
        class="m-error-text item-error"
        v-if="showError && aggreAgreement === false"
      >
        You must agree to the terms of the Data Use Agreement to place this
        order.
      </p>

      <b-form-checkbox
        class="item display-style mt-1 mb-1"
        v-model="IsContactMe"
        v-if="ShowIsContactMe"
      >
        Contact me to discuss reaching these same prospects via email, display,
        and/or social media.
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import MQuestion from "@/components/common/Mquestion";
import MErrorText from "@/components/common/MerrorText";
export default {
  components: {
    MQuestion,
    MErrorText,
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
    orderContact() {
      return this.$store.state.order.OrderContactInformation || {};
    },
    aggreAgreement: {
      get() {
        return this.$store.state.summary.aggreAgreement;
      },
      set(val) {
        this.$store.commit("summary/saveAggreAgreement", val);
      },
    },
    IsContactMe: {
      get() {
        return this.$store.state.order.IsContactMe; // @TODO@Wilson  lack not sl360 logic
      },
      set(val) {
        this.$store.commit("order/saveKey", ["IsContactMe", val]);
      },
    },
    ShowIsContactMe() {
      return (
        this.$store.state.order.ListType === 10 &&
        Math.min(
          this.$store.state.order.TotalAvailableQty,
          this.$store.state.order.TotalDesiredQty
        ) >= 10000
      );
    },
    IsEmailCampaign() {
      return this.$store.getters["order/IsEmailCampaign"];
    },
    showError() {
      return this.$store.getters["summary/showError"];
    },
    enablePlaceOrder() {
      return this.$store.getters["site/enablePlaceOrder"];
    },
  },
  methods: {
    showdatauseagreement() {
      this.$root.$emit("bv::show::modal", "datauseagreement");
    },
    showQuestion() {
      this.$root.$emit("bv::show::modal", "question");
    },
    updateContact(key, e) {
      this.$store.commit("order/updateContactInformation", {
        key: key,
        val: e.target.value,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  font-size: 13px;
}
.item-error {
  margin-left: 24px;
  margin-top: -8px;
}
.demo-box {
  margin-left: 8px;
  margin-bottom: 0px;
  margin-top: 8px;
}
.card-margin {
  margin: 10px auto;
}
.display-style {
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MCheckTerms.vue